import request from '@services/request';
import { getEnv } from '@shared/utils/env';
import CryptoJS from 'crypto-js';

const CORRESPONSAL_RESOURCE = '/api/v1/corresponsal';

const encryptObject = (data) => {
  const jsonString = JSON.stringify(data);
  const secretKey = getEnv().VITE_ENCRYPTION_KEY;
  return CryptoJS.AES.encrypt(jsonString, secretKey).toString();
};

const resetPasswordUser = async (params) => {
  const result = await request.post(`${CORRESPONSAL_RESOURCE}/requestChangePassword`, params);
  const { data } = result;
  return data;
};

const validResetPasswordHash = async (hash) => {
  const result = await request.get(`${CORRESPONSAL_RESOURCE}/validResetPasswordHash`, {
    hash,
  });
  const { data } = result;
  return data;
};

const resetPasswordHashed = async (params) => {
  const result = await request.post(`${CORRESPONSAL_RESOURCE}/resetPassword`, params);
  const { data } = result;
  return data;
};

const changePasswordUser = async (params) => {
  const encryptedData = encryptObject(params);
  const result = await request.post(`${CORRESPONSAL_RESOURCE}/changePassword`, { data: encryptedData });
  const { data } = result;
  return data;
};

const getUsers = async (search = {}, page = 0, size = 5, sorting = {}) => {
  const params = {
    mail: search.mail ?? '',
    role: search.role ?? '',
    limit: size,
    offset: page,
    ...sorting,
  };
  const result = await request.get(`${CORRESPONSAL_RESOURCE}/employees`, params);
  const { data } = result;
  return data;
};

const getUsersReport = async (search, fetchAll = 0, page = 1, size = 3, sorting = {}) => {
  const params = {
    ...search,
    limit: size,
    offset: page,
    fetchAll,
    ...sorting,
  };
  const result = await request.get(`${CORRESPONSAL_RESOURCE}/reports/users/correspondent`, params);
  const { data } = result;
  return data;
};

const getUsersReportBank = async (search, fetchAll = 0, page = 1, size = 3, sorting = {}) => {
  const params = {
    ...search,
    limit: size,
    offset: page,
    fetchAll,
    ...sorting,
  };
  const result = await request.get(`${CORRESPONSAL_RESOURCE}/reports/users`, params);
  const { data } = result;
  return data;
};

const getUsersCorrepondentAllReport = async (search, fetchAll = 0, page = 1, size = 3, sorting = {}) => {
  const params = {
    ...search,
    limit: size,
    offset: page,
    fetchAll,
    ...sorting,
  };
  const result = await request.get(`${CORRESPONSAL_RESOURCE}/reports/users/correspondent/all`, params);
  const { data } = result;
  return data;
};

const createUser = async (user) => {
  const result = await request.post(`${CORRESPONSAL_RESOURCE}/employees`, user);
  const { data } = result;
  return data;
};

const importUsers = async (users) => {
  const body = {
    data: users.map((user) => {
      const newData = { ...user };
      delete newData.index;
      delete newData.sheetRow;
      return newData;
    }),
  };
  const result = await request.post(`${CORRESPONSAL_RESOURCE}/employees-import`, body);
  const { data } = result;
  return data;
};

const updateUser = async (userId, user) => {
  const result = await request.put(`${CORRESPONSAL_RESOURCE}/employees/${userId}`, user);
  const { data } = result;
  return data;
};

const deleteUser = async (userId) => {
  const result = await request.methodDelete(`${CORRESPONSAL_RESOURCE}/employees/${userId}`);
  const { data } = result;
  return data;
};

const getUserInformationByUnlockHash = async (hash) => {
  const { data } = await request.get(`${CORRESPONSAL_RESOURCE}/users/unlock-hash/${hash}`);
  return data;
};

const unlockUserByUnlockHash = async (hash, userUnlockHash) => {
  const { data } = await request.put(`${CORRESPONSAL_RESOURCE}/users/unlock-hash/${hash}`, userUnlockHash);
  return data;
};

const getUsersByParams = async (correspondentId) => {
  const { data } = await request.get(`${CORRESPONSAL_RESOURCE}/users/locked?correspondent_id=${correspondentId}`);
  return data;
};

const getLockedCorrespondentUsers = async (offset, limit, sorting, correspondentId, isAdminBank) => {
  const params = { offset, limit, ...sorting };
  if (correspondentId) {
    params.correspondent_id = correspondentId;
  }
  if (isAdminBank) {
    params.isAdminBank = isAdminBank;
  }
  const { data } = await request.get(`${CORRESPONSAL_RESOURCE}/users/locked-crsp`, params);
  return data;
};

const unlockUserByMail = async (body) => {
  const { data } = await request.put(`${CORRESPONSAL_RESOURCE}/users/unlock`, body);
  return data;
};

export {
  changePasswordUser,
  createUser,
  deleteUser,
  getLockedCorrespondentUsers,
  getUserInformationByUnlockHash,
  getUsers,
  getUsersByParams,
  getUsersCorrepondentAllReport,
  getUsersReport,
  getUsersReportBank,
  importUsers,
  resetPasswordHashed,
  resetPasswordUser,
  unlockUserByMail,
  unlockUserByUnlockHash,
  updateUser,
  validResetPasswordHash
};

